import { PDFDocument, PDFDict, PDFName, PDFArray, PDFBool, PDFString, rgb } from 'pdf-lib'
const FileDownload = require('js-file-download');

const originalCheckboxFields = new Set(["type-of-legal-entity ","charity-objective 2","licensee-details-communication 2","licence-contact details-communications 2","contact-details-same-as-licence-contact-details 2","account-contact-preference 2","contact-details-same-as-licence-contact-details 3","account-contact-preference 4","sponsor-contact-preference","antenna-directional 2","antenna-directional 3","tx-outdoor 2","tx-outdoor 3","declaration-partners 2"]);

let pdfCheckBoxes = {
	"Type of legal entity": [{
		"value": "/Individual#20or#20sole#20trader",
		"page": 2,
		"rect": [69.5905, 639.101, 83.7638, 657.168]
	}, {
		"value": "/Incorporated#20association",
		"page": 2,
		"rect": [69.5905, 624.487, 83.7638, 638.66]
	}, {
		"value": "/Limited#20company#20or#20PLC",
		"page": 2,
		"rect": [69.5905, 608.046, 83.7638, 622.219]
	}, {
		"value": "/Local#20government",
		"page": 2,
		"rect": [69.5905, 591.605, 83.7638, 605.778]
	}, {
		"value": "/NHS#20England#20and#20Wales1",
		"page": 2,
		"rect": [69.5905, 575.164, 83.7638, 589.337]
	}, {
		"value": "/NHS#20Northern#20Ireland",
		"page": 2,
		"rect": [69.5905, 558.723, 83.7638, 572.896]
	}, {
		"value": "/Crown",
		"page": 2,
		"rect": [69.5905, 542.779, 83.7638, 556.952]
	}, {
		"value": "/NHS#20Scotland",
		"page": 2,
		"rect": [225.638, 641.052, 239.811, 655.225]
	}, {
		"value": "/Non-UK#20company#20or#20PLC",
		"page": 2,
		"rect": [225.638, 624.611, 239.811, 638.784]
	}, {
		"value": "/Non-UK#20government#20or#20administration",
		"page": 2,
		"rect": [225.638, 601.757, 239.811, 615.93]
	}, {
		"value": "/Partnership",
		"page": 2,
		"rect": [225.638, 578.69, 239.811, 592.863]
	}, {
		"value": "/Public#20body",
		"page": 2,
		"rect": [225.638, 562.249, 239.811, 576.422]
	}, {
		"value": "/Registered#20charity",
		"page": 2,
		"rect": [225.638, 545.808, 239.811, 559.981]
	}, {
		"value": "/Government",
		"page": 2,
		"rect": [379.484, 640.273, 393.658, 654.446]
	}, {
		"value": "/Unincorporated#20association",
		"page": 2,
		"rect": [379.484, 623.832, 393.658, 638.005]
	}, {
		"value": "/University#20or#20educational",
		"page": 2,
		"rect": [379.484, 607.556, 393.658, 621.729]
	}, {
		"value": "/Community#20interest",
		"page": 2,
		"rect": [379.484, 591.115, 393.658, 605.288]
	}, {
		"value": "/Royal#20charter",
		"page": 2,
		"rect": [379.484, 574.674, 393.658, 588.848]
	}, {
		"value": "/Religious#20body",
		"page": 2,
		"rect": [379.484, 558.233, 393.658, 572.407]
	}],
	"If registered charity, is its objective the safety of human life": [{
		"value": "/Yes",
		"page": 2,
		"rect": [69.2736, 268.624, 83.4468, 282.798]
	}, {
		"value": "/No",
		"page": 2,
		"rect": [69.2736, 252.183, 83.4468, 266.357]
	}],
	"Licensee communication preference": [{
		"value": "/Email",
		"page": 3,
		"rect": [70.1575, 558.227, 84.3307, 572.4]
	}, {
		"value": "/Leter",
		"page": 3,
		"rect": [70.1575, 541.748, 84.3307, 555.921]
	}],
	"Licence contact communication preference": [{
		"value": "/Email",
		"page": 3,
		"rect": [69.3071, 327.156, 83.4803, 341.329]
	}, {
		"value": "/Leter",
		"page": 3,
		"rect": [69.3071, 310.677, 83.4803, 324.85]
	}],
	"Tick if details are the same as those in question B.4 \\(Licence contact details\\)": [{
		"value": "/details#20are#20the#20same#20as#20those#20entered#20for#20licence#20contact",
		"page": 3,
		"rect": [72, 226.498, 86.1732, 240.671]
	}, {
		"value": "/details#20are#20the#20same#20as#20those#20entered#20for#20licence#20contact",
		"page": 4,
		"rect": [72, 760.535, 86.1732, 774.709]
	}],
	"Accounts contact communication preference": [{
		"value": "/Email",
		"page": 3,
		"rect": [72, 62.5274, 86.1732, 76.7007]
	}, {
		"value": "/Leter",
		"page": 3,
		"rect": [72, 46.0487, 86.1732, 60.222]
	}, {
		"value": "/Email",
		"page": 4,
		"rect": [72, 596.565, 86.1732, 610.738]
	}, {
		"value": "/Leter",
		"page": 4,
		"rect": [72, 580.086, 86.1732, 594.26]
	}],
	"sponsor communication preference": [{
		"value": "/Email",
		"page": 5,
		"rect": [72, 604.185, 86.1732, 618.358]
	}, {
		"value": "/Leter",
		"page": 5,
		"rect": [72, 587.706, 86.1732, 601.88]
	}],
	"Declaration - Tick if apllication is for self and partners": [{
		"value": "/Yes",
		"page": 9,
		"rect": [243.071, 518.14, 257.244, 532.313]
	}]
}

let transmitterCheckboxes = {
    "Is the antenna directional": [{
        "value": "/Yes",
        "page": 6,
        "rect": [68.8819, 197.187, 83.0551, 211.361]
    }, {
        "value": "/No",
        "page": 6,
        "rect": [68.8819, 177.26, 83.0551, 191.434]
    }],
    "Indicate whether the transmission is planned to occur outdoors:": [{
        "value": "/Yes",
        "page": 7,
        "rect": [70.3012, 366.408, 84.4745, 380.581]
    }, {
        "value": "/No",
        "page": 7,
        "rect": [70.3012, 346.905, 84.4745, 361.078]
    }]}

const iterateOverAnnotationsFindCheckBoxesAndCoordinates = (pdfDoc) =>{
    let boxIndex = {}
    for (let page of pdfDoc.getPageIndices().splice(2)){
        const annots = pdfDoc.getPage(page).node.Annots();
        for (let idx = 0; idx < annots.size(); idx++) {
            const annot = annots.lookup(idx, PDFDict)
            const tVal = annot.lookup(PDFName.of('TU'))
            
            //console.log(annot.lookup(PDFName.of('AP')).lookup(PDFName.of('N')))
            //console.log(annot.lookup(PDFName.of('AP')).lookup(PDFName.of('N')).dict)
            try {
                for (let e of annot.lookup(PDFName.of('AP')).lookup(PDFName.of('N')).dict){
                    if (e[0].encodedName==="/Off"){
                        continue
                    }

                    let json = {
                        value: e[0].encodedName,
                        page: page,
                        rect: annot.lookup(PDFName.of('Rect')).array.map(x => x["numberValue"])
                    }
                    if (tVal.value in boxIndex){
                        boxIndex[tVal.value].push(json)
                    } else {
                        boxIndex[tVal.value] = [json]
                    }
                }
            } catch(error){

            }

        }
    }

}


const postProcessCopiedAnnots = (page, offset) => {
    const acroForm = page.doc.catalog.lookup(PDFName.of('AcroForm'), PDFDict);
    const acroFields = acroForm.lookup(PDFName.of('Fields'), PDFArray);
    
    acroForm.set(PDFName.of('NeedAppearances'), PDFBool.True);
    
    const annots = page.node.Annots();
    for (let idx = 0; idx < annots.size(); idx++) {
        const annot = annots.lookup(idx, PDFDict);
        if (!annot.lookup(PDFName.of('T'))){
            continue
        }
        const tVal = (annot.lookup(PDFName.of('T'))).value;
    
        annot.set(PDFName.of('P'), page.ref);
        annot.set(PDFName.of('T'), PDFString.of(`${tVal}_${offset}`));
        annot.delete(PDFName.of('AP'));
    
        acroFields.push(annots.get(idx));
    }
    };



const generatePDF = async (emptyFormBytes, userInfo, requestID, ProjectOverview, MapSelection, TransmittingStations, AnalysisDetails, MNOConsultation, appendixBytes) => {
    const pdfDoc = await PDFDocument.load(emptyFormBytes)
    let form = pdfDoc.getForm()
    const fields = form.getFields()
    //remove old checkboxes
    let checkboxFieldNames = []
    fields.forEach(field => {
        const name = field.getName()
        if (originalCheckboxFields.has(name)){
        form.removeField(field)
        checkboxFieldNames.push(name)
        }
      })
    //add new checkboxes(except transmitters)
    for (let field in pdfCheckBoxes){
        for (let option of pdfCheckBoxes[field]){
            let rect = option.rect
            const checkBox = form.createCheckBox(field+`|${option.page}|`+option.value)
            checkBox.addToPage(pdfDoc.getPage(option.page), {
                x: rect[0],
                y: rect[1],
                width: 15,
                height: 15,
                borderWidth: 1,
                borderColor: rgb(0,0,0),
                color: rgb(1, 1, 1),
                opacity: 0.5,
                borderOpacity: 0.75,
            })
        }
    }
    //Fill Section A
    let section_a_text_fields = [
        ["licenceename3", "licence-contact details-name 2"],
        ["licenceeaddress3", "licence-contact details-address 2"],
        ["licenceepostcode3", "licence-contact details-postcode 2"],
        ["telephone3", "licence-contact details-telephone 2"],
        ["licenceecountry3","licence-contact details-country 2"],
        ["mobile3", "licence-contact details-mobile 2"],
        ["fax3", "licence-contact details-fax 2"],
        ["email3", "licence-contact details-email 2"],

        ["licenceename4", "account-contact-name 2"],
        ["licenceeaddress4", "account-contact-address 2"],
        ["licenceepostcode4", "account-contact-postcode 2"],
        ["telephone4", "account-contact-telephone 2"],
        ["licenceecountry4","account-contact-country 2"],
        ["mobile4", "account-contact-mobile 2"],
        ["fax4", "account-contact-fax 2"],
        ["email4", "account-contact-email 2"],

        ["licenceename5", "account-contact-name 3"],
        ["licenceeaddress5", "account-contact-address 3"],
        ["licenceepostcode5", "account-contact-postcode 3"],
        ["telephone5", "account-contact-telephone 3"],
        ["licenceecountry5","account-contact-country 3"],
        ["mobile5", "account-contact-mobile 3"],
        ["fax5", "account-contact-fax 3"],
        ["email5", "account-contact-email 3"]
        ]
    
    if (userInfo.existingcustomer==="true"){
        form.getTextField("customer-ref-no").setText(userInfo.customernumber)
    } else {
        let entityFieldLookup = {'indiv': '/Individual#20or#20sole#20trader', 'corp': '/Incorporated#20association', 'limit': '/Limited#20company#20or#20PLC', 'localgov': '/Local#20government', 'nhsenglnad': '/NHS#20England#20and#20Wales1', 'nhsireland': '/NHS#20Northern#20Ireland', 'crown': '/Crown', 'nhsscotland': '/NHS#20Scotland', 'nonukcompany': '/Non-UK#20company#20or#20PLC', 'nonukgov': '/Non-UK#20government#20or#20administration', 'partnership': '/Partnership', 'publicbody': '/Public#20body', 'charity': '/Registered#20charity', 'gov': '/Government', 'unincorporatedassociation': '/Unincorporated#20association', 'university': '/University#20or#20educational', 'communityinterest': '/Community#20interest', 'charter': '/Royal#20charter', 'religious': '/Religious#20body', 'legal': ''}
        form.getCheckBox(`Type of legal entity|2|${entityFieldLookup[userInfo.entity]}`).check()
        if (["indiv", "partnership"].includes(userInfo.entity)){
            form.getTextField("individual-name 2").setText(userInfo.name)
        } else if (["limit", "nonukcompany", "corp"].includes(userInfo.entity)){
            form.getTextField("company-details-name 2").setText(userInfo.companyname)
            form.getTextField("company-details-registration 2").setText(userInfo.companyregnumber)
        } else if (userInfo.entity === "charity"){
            form.getTextField("charity-details-name 2").setText(userInfo.charityname)
            form.getTextField("charity-details-registration 2").setText(userInfo.charityregnumber)
            if (userInfo.humansafety){
                form.getCheckBox("If registered charity, is its objective the safety of human life|2|/Yes").check()
            } else {
                form.getCheckBox("If registered charity, is its objective the safety of human life|2|/No").check()
            }
        } else if (userInfo.entity === "legal"){
            form.getTextField("other-details-name 2").setText(userInfo.legalentityname)
            form.getTextField("other-details-registration 2").setText(userInfo.regnumber)
        }
        section_a_text_fields = section_a_text_fields.concat([
            ["licenceename", "licensee-details-name 2"],
            ["tradingname", "licensee-details-trading 2"],
            ["licenceeaddress", "licensee-details-address 2"],
            ["licenceepostcode", "licensee-details-postcode 2"],
            ["telephone", "licensee-details-telephone 2"],
            ["licenceecountry","licensee-details-country 2"],
            ["mobile", "licensee-details-mobile 2"],
            ["fax", "licensee-details-fax 2"],
            ["email", "licensee-details-email 2"]])
            form.getCheckBox("Licensee communication preference|3|/Email").check()
    }
    for (let pair of section_a_text_fields){
        form.getTextField(pair[1]).setText(userInfo[pair[0]])
    } 

    let startDate = new Date(ProjectOverview.selectionRange.startDate)
    let endDate = new Date(ProjectOverview.selectionRange.endDate)
    let padNumber = (dateNumber) => { return `${dateNumber<=9 ? `0${dateNumber}` : `${dateNumber}`}`}

    //Fill Section B
    form.getCheckBox("Licence contact communication preference|3|/Email").check()
    form.getCheckBox("Accounts contact communication preference|3|/Email").check()
    form.getCheckBox("Accounts contact communication preference|4|/Email").check()
    for (let pair of [
        ["porject-description 2", ProjectOverview.form.projectdescription],
        ["project-description-external-manager 2",  ProjectOverview.form.projectdescriptionmno ?  ProjectOverview.form.projectdescriptionmno : ProjectOverview.form.projectdescription],
        ["project-start-date", `${padNumber(startDate.getDate())}-${padNumber(startDate.getMonth())}-${startDate.getFullYear()}`],
        ["project-end-date", `${padNumber(endDate.getDate())}-${padNumber(endDate.getMonth())}-${endDate.getFullYear()}`],
        ["details-of-operation", ProjectOverview.form.operationdetails],
        ["details-timings", ProjectOverview.form.details],
        ["details-tx", ProjectOverview.form.duration],
        ["details-days-per-week", ProjectOverview.form.days],
        ["sponsor-name", MNOConsultation.form.name],
        ["sponsor-address", MNOConsultation.form.address],
        ["sponsor-postcode", MNOConsultation.form.postcode],
        ["sponsor-country", MNOConsultation.form.country],
        ["sponsor-tel", MNOConsultation.form.telephone],
        ["sponsor-mobile", MNOConsultation.form.mobile],
        ["sponsor-fax", MNOConsultation.form.fax],
        ["sponsor-email", MNOConsultation.form.email]
    ]){
        form.getTextField(pair[0]).setText(String((pair[1]!= undefined) ? pair[1] : ""))
    }
    if (MNOConsultation.form.email){
        form.getCheckBox("sponsor communication preference|5|/Email").check()
    } else if (MNOConsultation.form.address){
        form.getCheckBox("sponsor communication preference|5|/Leter").check()
    }

    let MNOName = MapSelection.series_lookup[MapSelection.series_index][2]
    let coverage_percentage = parseFloat(AnalysisDetails.coverage_percentage)
    let interference_area = parseFloat(AnalysisDetails.interference_area)
    let inverse_coverage_percentage = parseFloat(AnalysisDetails.inverse_coverage_percentage)
    let selectedFrequencyLowerBound = parseFloat(MapSelection.selected_freqs[0])
    let selectedFrequencyUpperBound = parseFloat(MapSelection.selected_freqs[1])

    // Fill section C(one for each transmitter)
    let stationIndex = 0
    let tranmitterPageInsertionIndex = 9
    for (let station of TransmittingStations.stations){
        let country = ""
        let postal_code = ""
        for (let c of station.address_components){
            for (let type of c.types){
                if (type === "administrative_area_level_1"){
                    country = (c.long_name) ? c.long_name : ""
                    break
                } else if (type === "postal_code") {
                    postal_code = (c.long_name) ? c.long_name : ""
                    break
                }
            }
        }
        for (let sector of station.sectors){
            let ofset = ""
            if (stationIndex > 0){
                ofset = `_${stationIndex}`
                const [section_c_p1,section_c_p2,section_c_p3] = await pdfDoc.copyPages(pdfDoc, [6,7,8]);
                postProcessCopiedAnnots(section_c_p1, stationIndex)
                postProcessCopiedAnnots(section_c_p2, stationIndex)
                postProcessCopiedAnnots(section_c_p3, stationIndex)
                pdfDoc.insertPage(tranmitterPageInsertionIndex++ ,section_c_p1);
                pdfDoc.insertPage(tranmitterPageInsertionIndex++ ,section_c_p2);
                pdfDoc.insertPage(tranmitterPageInsertionIndex++ ,section_c_p3);
            }
            
            let [bg1, bg2, bg3] = ["","",""]
            
            if (station.britgrid.length>=4){
                [bg1, bg2, bg3] = [station["britgrid"].substring(0,2),station["britgrid"].substring(2,1+station["britgrid"].length/2),station["britgrid"].substring(1+station["britgrid"].length/2,station["britgrid"].length)]
            }
            for (let pair of [
                //Same for all transmitter pages
                [`freq-details-class${ofset}`, `${(selectedFrequencyUpperBound-selectedFrequencyLowerBound).toFixed()}M00D7W`],
                [`method-of-supression 3${ofset}`,`The toolkit used to generate this application (see Appendix A) maintains up-to-date coverage data with the incumbent MNO ${MNOName}, including for the targeted deployment band of ${selectedFrequencyLowerBound}-${selectedFrequencyUpperBound} MHz. ${interference_area <= 5 ? `Using the provided transmitter configuration information, we confirmed that ${MNOName} does not provide coverage in the desired operating area. ` : ""} \n\nAppendix C of this application provides additional details on our assesment of current usage of the requested frequencies at this location.`],
                [`method-of-supression 1${ofset}`,`The toolkit used to generate this application (see Appendix A) maintains up-to-date coverage data with the incumbent MNO ${MNOName}, including for the targeted deployment band of ${selectedFrequencyLowerBound}-${selectedFrequencyUpperBound} MHz. ${interference_area <= 5 ? `Using the provided transmitter configuration information, we determined via analysis and modeling that the planned deployment will not result in aggregate interference levels exceeding -115 dBm within the coverage area for ${MNOName}. ` : ""}Appendix D of this application provides additional details on our assessment of how the planned deployment detailed in this application will not result in interference to other users of the radio spectrum.${interference_area <= 5 ? `\n\nAdditionally, the agreement included as Appendix F of this application, provides further assurances that the planned deployment will not interferer with the operations of ${MNOName}.` : ""}\n\nIn the event that there are concerns due to the risk of interference, please contact us and we can take appropriate actions to minimize this risk (e.g., adjusting site locations, transmit power levels, antenna configuration).`],
 
                //Site specific details
                [`station-grid-ref-a2${ofset}`,bg1],
                [`station-grid-ref-a3${ofset}`,bg2],
                [`link-grid-ref-a4${ofset}`,bg3],
                [`site-address${ofset}`,station.address],
                [`site-postcode${ofset}`,postal_code],
                [`site-country${ofset}`,country],
                [`freq-details-operation${ofset}`,`${selectedFrequencyLowerBound}-${selectedFrequencyUpperBound}`],
                [`freq-details-bandwidth${ofset}`,(selectedFrequencyUpperBound-selectedFrequencyLowerBound).toFixed(1)],
                
                //Sector specific details
                [`antenna-type${ofset}`,sector.antenna],
                [`antenna-gain-dbi 2${ofset}`,sector.nominal_gain_dbi],
                [`antenna-polarisation${ofset}`,sector.polarisation],
                [`fixed-beam-horizontal 2${ofset}`,sector.horizontal_beamwidth_deg],
                [`fixed-beam-vertical 2${ofset}`,sector.vertical_beamwidth_deg],
                [`fixed-beam-tilt 2${ofset}`,sector.azimuth],
                [`fixed-beam-azimuth 2${ofset}`,sector.tilt + " (below horizontal)"],
                [`peak-power-eirp${ofset}`,sector.eirp_dbw],
                [`rf-power${ofset}`,sector.peak],
                //[`antenna-height-ground${ofset}`,sector.elevation_m_AGL],
                [`antenna-height-ground 2${ofset}`,sector.elevation_m_AGL],
                //[`antenna-height-sea${ofset}`,sector.elevation_m_AMSL],
                [`antenna-height-sea 2${ofset}`,sector.elevation_m_AMSL]
            ]){
                form.getTextField(pair[0]).setText(String((pair[1]!= undefined) ? pair[1] : ""))
            }
            let directionalCheckbox = form.createCheckBox(`outdoor-transmission${ofset}`)
            let outdoorCheckbox = form.createCheckBox(`not-outdoor-transmission${ofset}`)
            let NOTdirectionalCheckbox = form.createCheckBox(`directional-antenna${ofset}`)
            let NOToutdoorCheckbox = form.createCheckBox(`not-directional-antenna${ofset}`)
            
            
            directionalCheckbox.addToPage(pdfDoc.getPage(stationIndex*3+6), {
                x: 68.8819,
                y: 197.187,
                width: 15,
                height: 15,
                borderWidth: 1,
                borderColor: rgb(0,0,0),
                color: rgb(1, 1, 1),
                opacity: 0.5,
                borderOpacity: 0.75,
            })
            NOTdirectionalCheckbox.addToPage(pdfDoc.getPage(stationIndex*3+6), {
                x: 68.8819,
                y: 177.26,
                width: 15,
                height: 15,
                borderWidth: 1,
                borderColor: rgb(0,0,0),
                color: rgb(1, 1, 1),
                opacity: 0.5,
                borderOpacity: 0.75,
            })
            outdoorCheckbox.addToPage(pdfDoc.getPage(stationIndex*3+7), {
                x: 70.3012,
                y: 366.408,
                width: 15,
                height: 15,
                borderWidth: 1,
                borderColor: rgb(0,0,0),
                color: rgb(1, 1, 1),
                opacity: 0.5,
                borderOpacity: 0.75,
            })
            NOToutdoorCheckbox.addToPage(pdfDoc.getPage(stationIndex*3+7), {
                x: 70.3012,
                y: 346.905,
                width: 15,
                height: 15,
                borderWidth: 1,
                borderColor: rgb(0,0,0),
                color: rgb(1, 1, 1),
                opacity: 0.5,
                borderOpacity: 0.75,
            })
            if (sector.directional){
                directionalCheckbox.check()
            } else {
                NOTdirectionalCheckbox.check()
            }
            if (ProjectOverview.form.outdoor){
                outdoorCheckbox.check()
            } else {
                NOToutdoorCheckbox.check()
            }
            stationIndex++

        }
    }

    const appendix = await PDFDocument.load(appendixBytes)
    
    for (let appendixPage of await pdfDoc.copyPages(appendix, appendix.getPageIndices())){
        pdfDoc.addPage(appendixPage)
    }

    const pdfBytes = await pdfDoc.save()
    FileDownload(pdfBytes, 'prefilled-licencing-application.pdf');

  }
  
  export default generatePDF